import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GhostIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Ghost",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M14.59 30a6.47 6.47 0 0 1-3.88-1.36h.01c-.19-.14-.39-.3-.58-.46-.26-.24-.55-.47-.86-.67l-.03-.02c-.35-.2-.76-.39-1.19-.54l-.05-.02c-.87-.26-1.62-.7-2.24-1.28-.61-.7-.98-1.63-.98-2.64q0-.255.03-.51v.02-9.64C5 6.83 9.94 2 16.01 2S27.03 6.83 27.2 12.86v11.16c0 1.33-.58 2.51-1.51 3.33-1.09.82-2.38.71-3.62.61-.29-.04-.63-.06-.97-.06s-.68.02-1.01.07h.04c-.79.19-1.48.5-2.11.9l.03-.02c-.6.38-1.29.71-2.02.95l-.07.02c-.41.12-.89.19-1.38.19Zm1.38-26.98c-5.44 0-9.85 4.42-9.87 9.86v9.76a2.687 2.687 0 0 0 .61 2.13c.49.43 1.08.75 1.74.93h.03c.56.2 1.05.42 1.5.68l-.04-.02c.41.26.76.53 1.09.82.18.14.34.28.53.42a4.79 4.79 0 0 0 4.14.95h-.03c.68-.22 1.26-.5 1.8-.84l-.04.02c.71-.45 1.54-.81 2.43-1.02h.05c.34-.06.74-.08 1.14-.08s.8.03 1.19.08h-.05c1.09.08 2.03.16 2.71-.36.59-.6.96-1.42.96-2.32 0-.1 0-.2-.01-.3s0-10.83 0-10.83c0-5.46-4.43-9.88-9.89-9.88Zm-3.18 8.01a1.23 1.23 0 1 1-2.46 0 1.23 1.23 0 1 1 2.46 0m8.83 0a1.23 1.23 0 1 1-2.46 0 1.23 1.23 0 1 1 2.46 0m-3.87 4.55h-3.54c-.36 0-.66-.3-.66-.66s.3-.66.66-.66h3.54c.36 0 .66.3.66.66s-.3.66-.66.66"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("circle", {
        cx: "20.51",
        cy: "12.43",
        r: "1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.52 14.71c-1.26 0-2.29-1.03-2.29-2.29s1.03-2.29 2.29-2.29 2.29 1.03 2.29 2.29-1.03 2.29-2.29 2.29"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "11.37",
        cy: "12.43",
        r: "1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.37 14.71c-1.26 0-2.29-1.03-2.29-2.29s1.03-2.29 2.29-2.29 2.29 1.03 2.29 2.29-1.03 2.29-2.29 2.29M10.67 21.57a1.14 1.14 0 0 1-.83-1.93c1.62-1.7 3.79-2.64 6.1-2.64s4.49.94 6.1 2.64c.44.46.42 1.18-.04 1.62-.46.43-1.18.42-1.62-.04-1.18-1.24-2.76-1.93-4.45-1.93s-3.26.69-4.45 1.93c-.22.24-.53.36-.83.36ZM28.43 31.86h-1.14a1.14 1.14 0 1 1 0-2.28h1.14c.63 0 1.14-.51 1.14-1.14V27.3a1.14 1.14 0 1 1 2.28 0v1.14c0 1.89-1.54 3.43-3.43 3.43ZM4.43 31.86H3.29c-1.89 0-3.43-1.54-3.43-3.43v-1.14a1.14 1.14 0 1 1 2.28 0v1.14c0 .63.51 1.14 1.14 1.14h1.14a1.14 1.14 0 1 1 0 2.28ZM30.72 5.57c-.63 0-1.14-.51-1.14-1.14V3.29c0-.63-.51-1.14-1.14-1.14H27.3a1.14 1.14 0 1 1 0-2.28h1.14c1.89 0 3.43 1.54 3.43 3.43v1.14c0 .63-.51 1.14-1.14 1.14ZM1 5.57c-.63 0-1.14-.51-1.14-1.14V3.29C-.14 1.4 1.4-.14 3.29-.14h1.14a1.14 1.14 0 1 1 0 2.28H3.29c-.63 0-1.14.51-1.14 1.14v1.14c0 .63-.51 1.14-1.14 1.14ZM1 23.86c-.63 0-1.14-.51-1.14-1.14v-4.57a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M1 14.71c-.63 0-1.14-.51-1.14-1.14V9a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M30.71 23.86c-.63 0-1.14-.51-1.14-1.14v-4.57a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M30.71 14.71c-.63 0-1.14-.51-1.14-1.14V9a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M22.71 2.14h-4.57a1.14 1.14 0 1 1 0-2.28h4.57a1.14 1.14 0 1 1 0 2.28M13.57 2.14H9A1.14 1.14 0 1 1 9-.14h4.57a1.14 1.14 0 1 1 0 2.28M22.71 31.86h-4.57a1.14 1.14 0 1 1 0-2.28h4.57a1.14 1.14 0 1 1 0 2.28M13.57 31.86H9a1.14 1.14 0 1 1 0-2.28h4.57a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
GhostIcon.displayName = 'GhostIcon';